'use client';
export const createJobAccessLog = async (jobId: number) => {
  // 共通関数でパラメータを取得・整形
  const refParamsString = getCommaSeparatedParamArray('ref');
  const utmSourceParamsString = getCommaSeparatedParamArray('utm_source');

  try {
    const response = await fetch('/api/nextjs_api/job-access-logs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ jobId, refParamsString, utmSourceParamsString }),
    });
  } catch (error) {
    console.error('Error in client createEntryMember:', error);
    throw error;
  }
};

const getCommaSeparatedParamArray = (paramKey: string): string[] => {
  const urlParams = new URLSearchParams(window.location.search);
  const rawParam = urlParams.get(paramKey);
  return rawParam ? rawParam.split(',') : [];
};
